/* eslint-disable @typescript-eslint/no-var-requires */
import { state } from "./state.ts";

const ace = require("brace");

export async function open() {
  [state.fileHandle] = await window.showOpenFilePicker();
  const file = await state.fileHandle.getFile();
  const contents = await file.text();
  let editor = ace.edit("editor");
  editor = ace.edit("editor");
  editor.setValue(contents);
  const name = state.fileHandle.name.replace(".py", "");
  state.filename = name;
  state.opened = true;
  state.readonly = true;
}

export async function write() {
  // Create a FileSystemWritableFileStream to write to.
  const writable = await state.fileHandle.createWritable();
  // Write the contents of the file to the stream.
  const editor = ace.edit("editor");
  await writable.write(editor.getValue());
  // Close the file and write the contents to disk.
  await writable.close();
  const name = state.fileHandle.name.replace(".py", "");
  state.filename = name;
  state.opened = true;
  state.readonly = true;
}

export async function getNewFileHandle() {
  const options = {
    name: state.filename,
    types: [
      {
        description: "Python Files",
        accept: {
          "text/python": ".py"
        }
      }
    ]
  };
  const handle = await window.showSaveFilePicker(options);
  state.fileHandle = handle;
  const name = state.fileHandle.name.replace(".py", "");
  state.filename = name;
}
